import { HfsSettingsActionEnum } from 'fleet-data-model';
import { type Update } from '../../types';

export const mapSmartRoutinesRainGuardTarget = (update: Update) => {
  return [
    {
      hfsActionId: HfsSettingsActionEnum.MOWER_SMART_RAIN_GUARD,
      iprId: update.assetId,
      payload: {
        enabled: update.enabled,
      },
    },
  ];
};

export const mapSmartRoutinesFrostGuardTarget = (update: Update) => {
  return [
    {
      hfsActionId: HfsSettingsActionEnum.MOWER_SMART_FROST_GUARD,
      iprId: update.assetId,
      payload: {
        enabled: update.enabled,
      },
    },
  ];
};
